import { theme } from 'lib/style';
import React from 'react';
import { FaChevronRight } from 'react-icons/fa';
import { useHistory, useLocation } from 'react-router';
import styled, { useTheme } from 'styled-components/macro';

type BreadCrumbLink = {
  title: string;
  url: string;
  value?: string;
};

type BreadCrumbProps = {
  links: Array<BreadCrumbLink>;
  queryParams?: string;
};

const Container = styled.div`
  display: flex;
  margin-bottom: 24px;
`;

const BreadCrumb = styled.div`
  display: flex;
  align-items: center;
  color: ${props => props.theme.colors.primary[100]};
  font-size: 15px;
  font-weight: 500;
  cursor: pointer;
  div {
    text-decoration: underline;
  }
`;

const activeStyle = {
  color: theme.palette.covideoGray80,
  textDecoration: 'none',
};

export const BreadCrumbs = ({ links, queryParams }: BreadCrumbProps) => {
  const location = useLocation();
  const history = useHistory();
  const themes = useTheme();
  return (
    <Container>
      {links.map((item, index) => (
        <BreadCrumb key={'breadcrumb-' + index}>
          <div
            style={{ ...(item.url === location.pathname && activeStyle) }}
            onClick={() =>
              history.push(
                queryParams ? item.url + '?' + queryParams : item.url
              )
            }
          >
            {item.title}
          </div>
          {index !== links.length - 1 && (
            <FaChevronRight
              size={10}
              color={themes.colors.neutral[60]}
              style={{ margin: '0 10px' }}
            />
          )}
        </BreadCrumb>
      ))}
    </Container>
  );
};
